export default "__VITE_ASSET__DqKSigHy__"